import LogRepository from "../../ports/logRepository";

export type getLogsUsecase = (applicantId: string) => Promise<any>;

export const buildGetLogs = (dependencies: {
  logRepo: LogRepository;
}): getLogsUsecase => {
  const { logRepo } = dependencies;

  const getLogs: getLogsUsecase = async (applicantId: string) =>
    logRepo.getLogs(applicantId);

  return getLogs;
};
